import './utilidade'
import './cookie'


// WEBPACK FOOTER //
// ./src/services/index.js